export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || '';
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || '';
export const ADMIN_PASSWORD = import.meta.env.VITE_ADMIN_PASSWORD || '';